import { render, staticRenderFns } from "./ModalImportar.vue?vue&type=template&id=22ac67b4&scoped=true"
import script from "./ModalImportar.vue?vue&type=script&lang=js"
export * from "./ModalImportar.vue?vue&type=script&lang=js"
import style0 from "./ModalImportar.vue?vue&type=style&index=0&id=22ac67b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac67b4",
  null
  
)

export default component.exports